import { EditorialImageBlock } from "../../lib/storyblok/types/blocks/EditorialImageBlock";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { useLinks } from "../../lib/storyblok/useLinks";
import { imageSizes, isValidImageData } from "../../lib/utils/imageUtils";
import Editorial from "../../ui/Editorial/Editorial";
import ConditionalWrapper from "../ConditionalWrapper";
import StoryblokImage from "../StoryblokImage";
import FlexibleLinkWrapper from "../../components/Nestable/LinkWrapper/FlexibleLinkWrapper";

const EditorialImage: StoryblokBlockComponent<EditorialImageBlock> = ({
  image,
  caption,
  wide,
  link,
  linkTarget,
  linkTitle,
}) => {
  const resolveLink = useLinks();
  if (!image) return null;
  const hasLink = link ? link.id.length > 0 || link.url.length > 0 : false;
  const target = linkTarget ? "_blank" : "_self";
  const href = link ? resolveLink(link) : "/";
  const linkProps = {
    title: linkTitle,
    href,
    target,
  };
  return (
    <Editorial.Image
      image={
        <ConditionalWrapper
          shouldWrap={hasLink}
          wrapper={(children) => (
            <FlexibleLinkWrapper {...linkProps}>{children}</FlexibleLinkWrapper>
          )}
        >
          <>
            {isValidImageData(image) && (
              <StoryblokImage
                sizes={imageSizes("100vw", {
                  desktop: "1200px",
                })}
                resize={{ width: 1200 }}
                image={image}
                layout="fill"
                alt={caption}
              />
            )}
          </>
        </ConditionalWrapper>
      }
      caption={caption}
      wide={wide}
    />
  );
};

export default EditorialImage;
